module.exports = __webpack_public_path__ + "static/header-5575ee7bdf3e41705e0f2de1a8b79303.jpg";